import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { isAuthenticated } from '../../../../services/auth';
import { message } from 'antd';
import { getCategory, editCategory } from '../../../../services/category';
import UnifiedDashboard from '../../../../components/layout/UnifiedDashboard';
import './EditCategory.css';

const EditCategory = ({ match }) => {
  const [name, setName] = useState('');
  const { token } = isAuthenticated();
  const history = useHistory();

  useEffect(() => {
    const loadCategory = async () => {
      const data = await getCategory(match.params.categoryId);
      setName(data.data.name);
    };

    if (match.params.categoryId) {
      loadCategory();
    }
  }, [match.params.categoryId]);

  const handleChange = (e) => {
    setName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await editCategory(match.params.categoryId, { name, token });
      message.success('Categoria editada com sucesso', 4);
      history.push('/admin/add-category');
    } catch (err) {
      if (err.response?.status === 400) message.error(err.response.data, 4);
    }
  };

  return (
    <UnifiedDashboard title="Editar Categoria">
      <div className='edit-category-container'>
        <div className='edit-category-header'>
          <button
            className='edit-category-back-btn'
            onClick={() => history.push('/admin/add-category')}
            title='Voltar'
          >
            <i className='fas fa-arrow-left'></i>
          </button>
          <div>
            <h1 className='edit-category-title'>
              <i className='fas fa-edit'></i>
              Editar Categoria
            </h1>
            <p className='edit-category-subtitle'>Altere os dados da categoria</p>
          </div>
        </div>

        <div className='edit-category-card'>
          <form onSubmit={handleSubmit} className='edit-category-form'>
            <div className='edit-category-form-group'>
              <label className='edit-category-label'>
                <i className='fas fa-tag'></i>
                Nome da Categoria
              </label>
              <input
                type='text'
                className='edit-category-input'
                placeholder='Digite o novo nome da categoria'
                value={name}
                onChange={handleChange}
                required
              />
            </div>
            <button type='submit' className='edit-category-submit-btn'>
              <i className='fas fa-save'></i>
              Salvar Alterações
            </button>
          </form>
        </div>
      </div>
    </UnifiedDashboard>
  );
};

export default EditCategory;
